import { MOCK_EXTRAS, type MatchExtras } from './fixtures.ts'

// The one seam between the leagues and match pages and the fields no endpoint serves. An object, as in
// `data/activation.ts`: only a property can be replaced by a test.

/** Every fixture has extras, invented ones included: a match the API answered for and that
 *  this table does not list gets the empty set, never a failure. */
const NO_EXTRAS: Omit<MatchExtras, 'matchId'> = {
  official: false,
  bothOnVolee: false,
  durationMinutes: 0,
  recording: 'unavailable',
  unlocked: false,
  highlights: [],
  scoreLines: [],
  lineup: [],
}

export const mockReader = {
  matchExtras: (matchId: number): Promise<MatchExtras> =>
    Promise.resolve(
      MOCK_EXTRAS.find((one) => one.matchId === matchId) ?? { matchId, ...NO_EXTRAS },
    ),
}
